import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const getLayers = gql`
  query {
    layers(limit: 999999, page: 1) {
      id_layer
      nm_layer
      url
      metadata {
        descript
        source
        date
        type
        quality
        more_info
        download
      }
    }
  }
`

export const getLayersOptions = {
  props: (props) => ({
    ...props,
    getLayers() {
      if (props.data.loading) {
        return {}
      }

      return props.data.layers
    }
  })
}

export default graphql(getLayers, getLayersOptions)



// WEBPACK FOOTER //
// ./src/components/pages/App/App.getLayers.js